import { IIconProps } from "../types"

export default function IconLL1(props: IIconProps) {
  const width = props.size || props.width || (86 / 5) * 3
  const height = props.size || props.height || (115 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 86 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.6415 1.77185C53.2348 0.942119 35.9103 0.50226 25.3937 0.452276C14.8771 0.412289 11.1583 0.762177 8.57911 1.64189C5.98994 2.52161 4.52041 3.93116 3.34079 5.60063C2.16117 7.27009 1.26145 9.19947 0.811598 12.6284C0.361743 16.0573 0.361743 20.9757 0.641653 29.503C0.921563 38.0202 1.48138 50.1463 3.45075 63.2821C5.42012 76.4179 8.79904 90.5634 11.3882 98.8707C13.9774 107.178 15.7768 109.637 19.4856 111.347C23.1944 113.066 28.8226 114.036 34.8407 114.336C40.8588 114.646 47.2767 114.296 52.1651 113.366C57.0636 112.446 60.4325 110.957 62.9117 109.237C65.3809 107.528 66.9604 105.599 70.2793 95.8417C73.5983 86.0848 78.6566 68.5105 81.3058 56.6942C83.9449 44.878 84.1749 38.81 84.4548 32.1321C84.7347 25.4543 85.0746 18.1666 84.5048 13.5481C83.945 8.93955 82.4854 7.00018 80.0062 5.42068C77.537 3.84119 74.0481 2.61158 63.6415 1.77185Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
